import initShareholdersTabs from '../../scripts/initShareholdersTabs'

export default {
  mounted() {
    initShareholdersTabs();
  }
}
